import indigo from "@material-ui/core/colors/indigo";
import deepOrange from "@material-ui/core/colors/deepOrange";
import grey from "@material-ui/core/colors/grey";
import {createMuiTheme} from "@material-ui/core";

export default createMuiTheme({
  palette: {
    primary: {
      light: indigo[300],
      main: indigo[500],
      dark: indigo[700],
    },
    secondary: {
      light: deepOrange[300],
      main: deepOrange[500],
      dark: deepOrange[700],
    },
  },

  typography: {
    useNextVariants: true,
    subtitle1: {
      color: 'grey',
      fontSize: '0.9rem',
      marginBottom: 4
    },
    h1: {
      fontSize: '1.2rem',
      fontWeight: 400,
      marginBottom: 16
    },
    h2: {
      fontSize: '2.2rem',
      fontWeight: 300,
      marginBottom: 12
    },
    h3: {
      fontSize: '1.3rem',
      fontWeight: 400,
      marginBottom: 16
    },
    h4: {
      fontSize: '1.2rem',
      fontWeight: 500,
      color: grey[600],
      marginLeft: 4,
      marginTop: 4,
      marginBottom: 8
    },
    h5: {
      fontSize: '1.1rem',
      fontWeight: 400,
      marginBottom: 8
    },
    h6: {
      color: 'black',
      fontSize: '0.9rem'
    }
  },
});

